import styled from 'styled-components';

export const StyledMatchListControls = styled.div`
  width: 18rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: end;
  padding: 0.75rem;
  gap: 1rem;
  
  @media (max-height: 600px) {
    padding: 0.5rem;
    gap: 0.2em;
  }
`;

export const StyledNExtBattleButtonHolder = styled.div`
  width: 8rem;
  z-index: 199;
  position: absolute;
  bottom: 2rem;
  right: calc(2rem + calc(${({ theme }) => theme.hudPanelWidth} * var(--app-scale)));
`;

export const StyledBroadsiderHud = styled.div`
  width: 100vw;
  max-width: 100%;
  height: 100vh;
  max-height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: ${({ theme }) => theme.background};

  .expand-metaverse {
    position: absolute;
    top: 0;
    z-index: 0;
    top: ${({ theme }) => theme.navHeight};
    padding-top: 2rem;
    right: 0;
  }

  .expand-metaverse-button {
    background: ${({ theme }) => theme.baseYellow};
    padding: 1rem 0.25rem;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    border-left: ${({ theme }) => theme.selection};
    img {
      width: 1.5rem;
      transition: transform .2s linear;
    }
    border: solid 1px rgba(0, 0, 0, .16);
    transition: 0.2s linear;
    &:hover {
      background: ${({ theme }) => theme.brightYellow};
      border: solid 1px ${({ theme }) => theme.borderYellow};
      img {
        transform: translateX(-0.25rem);
      }
    }
  }

  .expand-metaverse-button-text {
    writing-mode: vertical-lr;
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 2rem;
    padding-right: 6px;
    font-weight: 700;
    color: black;
  }

  .player-label {
    z-index: 98;
    transition: linear .2s;
    position: absolute;
  }
  
  .player-label-you {
    left: ${({ theme }) => theme.frameOffset};
    top: 50%;
  }
  .player-label-opponent {
    right: ${({ theme }) => theme.frameOffset};
    top: 10%;
  }

  .hud-panel {
    z-index: 197;
    transition: linear .2s;
    position: absolute;
    width: ${({ theme }) => theme.hudPanelWidth};
    min-width: ${({ theme }) => theme.hudPanelWidth};
    max-width: ${({ theme }) => theme.hudPanelMaxWidth};
  }

  .hud-panel-full-height {
    --base-height: calc(100vh - ${({ theme }) => theme.navHeight} - ${({ theme }) => theme.frameOffset});
    height: var(--base-height);
  }

  .hud-panel-move-back {
    z-index: 196;
  }

  .hud-panel-move-front {
    z-index: 198;
  }

  .hud-panel-content {
    height: calc(var(--base-height) / var(--app-scale));
    animation: popup-animation-translate 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0s 1 normal forwards, popup-animation-opacity 0.1s cubic-bezier(0.5, 0.35, 0, 1) 0s 1 normal forwards;
    transform: scale(var(--app-scale));
    transform-origin: 100% 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    backdrop-filter: blur(10px);
  }

  .hud-panel-dynamic-width {
    width: auto;
    max-width: unset;
  }

  .hud-mobile {
    z-index: 0;
    transition: linear .2s;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .hud-mobile-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
  }

  .hud-panel-left {
    left: ${({ theme }) => theme.frameOffset};
  }

  .hud-panel-right {
    -webkit-backdrop-filter: blur(10px);
    -moz-backdrop-filter: blur(10px);
    -ms-backdrop-filter: blur(10px);
    -o-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    right: ${({ theme }) => theme.frameOffset};
  }

  .hud-panel.no-blur {
    backdrop-filter: none;
  }

  .hud-panel-right-additional {
    --base-height: ${({ theme }) => 'calc(100vh - '+theme.navHeight+' - ' +theme.frameOffset + ')'};
    height: var(--base-height);
    -webkit-backdrop-filter: blur(10px);
    -moz-backdrop-filter: blur(10px);
    -ms-backdrop-filter: blur(10px);
    -o-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    right: calc(${({ theme }) => theme.frameOffset} + calc(${({ theme }) => theme.hudPanelWidth} * var(--app-scale)));
  }

  .hud-panel-top {
    top: ${({ theme }) => theme.navHeight};
  }

  .hud-panel-bottom {
    bottom: ${({ theme }) => theme.frameOffset};
  }

  .hud-panel-b {
    left: ${({ theme }) => theme.frameOffset};
  }

  .scroller {
    height: 100%;
    width: 100%;
    padding: ${({ theme }) => theme.frameOffset};
    padding-top: 0px;
  }

  .hud-frame {
    border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
    border-bottom: none;
    position: absolute;
    left: ${({ theme }) => theme.frameOffset};
    right: ${({ theme }) => theme.frameOffset};
    top: ${({ theme }) => theme.navHeight};
    bottom: ${({ theme }) => theme.frameOffset};
  }

  .hud-frame-bottom {
    border: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
    border-top: none;
    position: absolute;
    height: 1px;
    left: ${({ theme }) => theme.frameOffset};
    right: ${({ theme }) => theme.frameOffset};
    bottom: ${({ theme }) => theme.frameOffset};
    z-index: 100;
  }

  .hud-metaverse-logo-border {
    border: solid ${({ theme }) => theme.frameWidth} white;
    border-right: none;
    border-top: none;
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    min-width: ${({ theme }) => theme.cornerSize};
    min-height: ${({ theme }) => theme.cornerSize};
  }

  .hud-metaverse-logo-border-top {
    border: solid ${({ theme }) => theme.frameWidth} white;
    border-right: none;
    border-bottom: none;
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    min-width: ${({ theme }) => theme.cornerSize};
    min-height: ${({ theme }) => theme.cornerSize};
  }

  .hud-metaverse-logo {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: end;
    width: 100%;
    img {
      width: 100%;
      margin-bottom: ${({ theme }) => theme.cornerSize};
    }
    z-index: 101;
    position: relative;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    .hud-panel {
      width: 13vw;
    }

    .hud-panel-left {
      padding-left: 0;
    }

    .hud-panel-right {
      padding-right: 0;
    }
  }
`;
